import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationsService } from 'app/services/notifications.service';
import { EndpointDictionary } from 'app/utils/endpoints-dictionary';
import { FunctionsService, HttpService, LocalStorageService, MenuBreadCrumb, MessageService, SessionService } from 'brainloper-ui';
import { EmergingActivity } from 'app/models2/maintenance/emerging-activities';
import { BaseResponse } from 'app/models2/commos/base-response';
import { GenericResponse } from 'app/models2/commos/generic-response';

@Component({
  selector: 'app-fuel-requests-notification',
  templateUrl: './fuel-requests-notification.component.html',
  styleUrls: ['./fuel-requests-notification.component.scss']
})
export class FuelRequestsNotificationComponent implements OnInit {

  private urlActividadEmerg: string = `${EndpointDictionary.ActivityeEmerg.CRUD_ACTIVITY_EMERG_DATA}`

  public bodyActividad: EmergingActivity = {}
  public view: boolean = false
  public action: string = ''
  public formEdit: UntypedFormGroup
  public movil: boolean
  private order


  public rol: string = this.storage.get<string>('rol')
  private id_notificacion: number = this.session.getData('id_notificacion')

  public menuBreadCrumb:Array<MenuBreadCrumb> = [
    {
      name:"Inicio",
      router:'/inicio',
    },
    {
      name:"Notificaciones",
    },
    {
    name:"Solicitud Combustible",
    current:true
    }
  ]

  constructor(
    private activeRoute: ActivatedRoute,
    private http: HttpService,
    private message: MessageService,
    private session: SessionService,
    private functioEter: FunctionsService,
    private router: Router,
    private formBuilder: UntypedFormBuilder,
    private functions: FunctionsService,
    public notificationService: NotificationsService,
    private storage : LocalStorageService
  ) {
    this.formEdit = this.formBuilder.group({
      executionDate:''
    })
  }

  ngOnInit(): void {
    this.movil = screen.width > 600 ? false : true
    this.init()

  }

  async init() {
    this.message.openLoading('Cargando', 'Cargando Información')
    this.activeRoute.queryParamMap
      .subscribe(async(params) => {
        this.order = { ...params };
        //console.log(this.order.params.id_actividad_emergente)
       
          let res: Array<EmergingActivity> = await this.http.getDataBody(`${this.urlActividadEmerg}/${this.order.params.id_actividad_emergente}`)
          //console.log(res)
          if (res) {
            this.bodyActividad = res[0]
            this.bodyActividad.date =this.functioEter.dateIso(res[0].date)
            this.view = true
            this.message.closeLoading()

          } else {
            this.message.closeLoading()
          }
      }
      )
  }

  async response($event: string){
    //console.log($event)
    try {
      if ($event == 'autorizar') {
        this.message.openLoading('Cargando', 'Autorizando solicitud')
        this.session.setData('data', { action: 'solicitud', body:this.bodyActividad, id_notificacion:this.id_notificacion})
        this.message.closeLoading()
          this.message.SuccessToast('Solicitud Autorizada')
          this.router.navigate(["/combustible/autoriza_comb"])
          setTimeout(() => {
            this.router.navigate(["/combustible/autoriza_comb/detalle"])
          }, 500);
      }else{
        this.message.Warning('Desea rechazar la solicitud', '', true).then(
          (res: boolean) => {
            if(res==true){
              this.rechazarSolicitud()
            }
          }
        )
      }

    } catch (error) {
      this.message.Error('Error', error)
    }
  }

  async rechazarSolicitud(){
    this.message.openLoading('Cargando', 'Rechazando Solicitud')
    let bodyNotification = {
      descripcion:`Solicitud rechazada ${this.bodyActividad.description}`,
      notificado:this.bodyActividad.requests
  }

    let resDeleteActividad: BaseResponse<GenericResponse> = await this.http.deleteDataPromise(`${this.urlActividadEmerg}/${this.bodyActividad.id}`)

    if(resDeleteActividad['code']===0){
      this.notificationService.deleteNotificationByUrl(`notificaciones/solicitudCombustible?id_actividad_emergente=${this.bodyActividad.id}`)
          this.message.closeLoading()
          this.message.SuccessToast('Solicitud rechazada')
          await this.notificationService.sendNotificationInformative(bodyNotification.descripcion, bodyNotification.notificado)
          setTimeout(() => {
            this.router.navigate(["/inicio"])
          }, 500);
  }else{
      this.message.Error('Error', resDeleteActividad['message'])
    }
  }

  edit($event){
    this.formEdit.controls.executionDate.setValue(`${this.bodyActividad.date}T08:00:00.000Z`)
    this.view = false
    this.action = $event
  }

  async finalizar(data) {
    this.message.openLoading('Cargando', 'Actualizando solicitud')
    let form = {
      id: this.bodyActividad.id,
      requests: this.bodyActividad.requests,
      equipmentId: this.bodyActividad.equipmentId,
      date: this.functions.dateForm(data.executionDate)
    }

      let res: GenericResponse = await this.http.putDataBody(`${this.urlActividadEmerg}`, form)
      if (res) {
        this.message.SuccessToast('Solicitud actualizada correctamente')
        setTimeout(() => {
          this.router.navigate(['inicio'])
          this.message.closeLoading()
        }, 500);

      }
    //console.log(form)

  }

  back() {
    this.view = true
    this.action = 'soliciud'
  }

  errorMessage(){
    this.message.Error('Error', 'Complete los campos')
  }

}
